<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- 遮罩 -->
    <div class="absolute inset-0 bg-black/50" @click="$emit('close')"></div>

    <!-- 模态框 -->
    <div class="relative bg-white rounded-xl shadow-xl w-full max-w-6xl mx-4 max-h-[90vh] flex flex-col" style="animation: slideIn 0.2s ease-out;">
      <!-- 头部 -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200 shrink-0">
        <h3 class="text-lg font-semibold text-slate-900">{{ definition ? '编辑资料类型' : '新增资料类型' }}</h3>
        <button
          @click="$emit('close')"
          class="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Tab导航 -->
      <div class="flex border-b border-slate-200 px-6 shrink-0">
        <button
          v-for="tab in tabs"
          :key="tab.key"
          @click="activeTab = tab.key"
          class="px-4 py-3 text-sm font-medium border-b-2 transition-colors cursor-pointer"
          :class="activeTab === tab.key
            ? 'text-primary-600 border-primary-600'
            : 'text-slate-500 border-transparent hover:text-slate-700'"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- Tab内容 -->
      <div class="flex-1 overflow-y-auto p-6">
        <!-- 基础信息Tab -->
        <div v-show="activeTab === 'basic'" class="space-y-4">
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">
                分类 <span class="text-red-500">*</span>
              </label>
              <select
                v-model="form.categoryId"
                class="form-select-native w-full"
                :disabled="!!categoryId"
              >
                <option :value="categoryId" v-if="categoryId">{{ selectedCategoryName }}</option>
                <option v-else :value="null">请选择分类</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">
                类型编码 <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.code"
                type="text"
                :disabled="!!definition"
                class="form-input w-full"
                placeholder="如: id_card, contract"
              >
            </div>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">
                类型名称 <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.name"
                type="text"
                class="form-input w-full"
                placeholder="如: 身份证信息"
              >
            </div>
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">别名</label>
              <input
                v-model="form.nameAlias"
                type="text"
                class="form-input w-full"
                placeholder="如: 证件"
              >
            </div>
          </div>

          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">描述</label>
            <textarea
              v-model="form.description"
              rows="2"
              class="form-textarea"
              placeholder="请输入资料类型描述"
            ></textarea>
          </div>

          <div class="grid grid-cols-3 gap-4">
            <div>
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  v-model="form.allowMultiple"
                  type="checkbox"
                  :true-value="1"
                  :false-value="0"
                  class="w-4 h-4 text-primary-600 border-slate-300 rounded focus:ring-primary-500"
                >
                <span class="text-sm text-slate-700">允许多个</span>
              </label>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">排序</label>
              <input
                v-model.number="form.sort"
                type="number"
                class="form-input w-full"
              >
            </div>
            <div>
              <label class="block text-sm font-medium text-slate-700 mb-1">状态</label>
              <select
                v-model="form.status"
                class="form-select-native w-full"
              >
                <option :value="1">启用</option>
                <option :value="0">禁用</option>
              </select>
            </div>
          </div>
        </div>

        <!-- 文件配置Tab -->
        <div v-show="activeTab === 'file'" class="space-y-4">
          <div class="bg-slate-50 rounded-lg p-4">
            <div class="flex items-center justify-between mb-4">
              <h4 class="text-sm font-medium text-slate-700">文件上传配置</h4>
              <button
                @click="addFileField"
                class="px-3 py-1.5 bg-primary-600 text-white rounded-lg text-xs hover:bg-primary-700 transition-colors flex items-center gap-1 cursor-pointer"
              >
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                </svg>
                添加字段
              </button>
            </div>

            <div v-if="form.fileConfig.files.length === 0" class="text-center py-8 text-slate-400 text-sm">
              暂未配置文件上传字段，点击"添加字段"开始配置
            </div>

            <div v-else class="space-y-3">
              <div
                v-for="(file, index) in form.fileConfig.files"
                :key="index"
                class="bg-white rounded-lg border border-slate-200 p-4"
              >
                <div class="flex items-start gap-4">
                  <div class="flex-1 grid grid-cols-2 gap-3">
                    <div>
                      <label class="block text-xs font-medium text-slate-500 mb-1">字段编码</label>
                      <input
                        v-model="file.fieldCode"
                        type="text"
                        class="form-input w-full"
                        placeholder="如: front_photo"
                      >
                    </div>
                    <div>
                      <label class="block text-xs font-medium text-slate-500 mb-1">字段标签</label>
                      <input
                        v-model="file.label"
                        type="text"
                        class="form-input w-full"
                        placeholder="如: 正面照片"
                      >
                    </div>
                    <div>
                      <label class="block text-xs font-medium text-slate-500 mb-1">接受类型</label>
                      <input
                        v-model="file.accept"
                        type="text"
                        class="form-input w-full"
                        placeholder="如: image/*,.pdf,.doc"
                      >
                    </div>
                    <div>
                      <label class="block text-xs font-medium text-slate-500 mb-1">最大大小(KB)</label>
                      <input
                        v-model.number="file.maxSize"
                        type="number"
                        min="0"
                        class="form-input w-full"
                        placeholder="0为不限制"
                      >
                    </div>
                  </div>
                  <div class="flex items-center gap-2 pt-5">
                    <label class="flex items-center gap-1 cursor-pointer">
                      <input
                        v-model="file.required"
                        type="checkbox"
                        class="w-4 h-4 text-primary-600 border-slate-300 rounded focus:ring-primary-500"
                      >
                      <span class="text-xs text-slate-600">必填</span>
                    </label>
                    <button
                      @click="removeFileField(index)"
                      class="p-1 text-red-500 hover:bg-red-50 rounded transition-colors cursor-pointer"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 表单设计Tab -->
        <div v-show="activeTab === 'form'" class="h-[500px]">
          <FormBuilder v-model="form.formSchema" />
        </div>
      </div>

      <!-- 底部 -->
      <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl shrink-0">
        <button
          @click="$emit('close')"
          class="btn-secondary"
        >
          取消
        </button>
        <button
          @click="handleSave"
          class="btn-primary"
        >
          确定
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import FormBuilder from './FormBuilder.vue'

const props = defineProps({
  definition: {
    type: Object,
    default: null
  },
  categoryId: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['close', 'save'])

const activeTab = ref('basic')
const selectedCategoryName = ref('')

const tabs = [
  { key: 'basic', label: '基础信息' },
  { key: 'file', label: '文件配置' },
  { key: 'form', label: '表单设计' }
]

const form = reactive({
  categoryId: null,
  code: '',
  name: '',
  nameAlias: '',
  description: '',
  allowMultiple: 0,
  sort: 0,
  status: 1,
  fileConfig: {
    files: []
  },
  formSchema: {
    type: 'object',
    properties: {},
    required: []
  }
})

onMounted(() => {
  if (props.definition) {
    // 编辑模式
    form.categoryId = props.definition.categoryId
    form.code = props.definition.code
    form.name = props.definition.name
    form.nameAlias = props.definition.nameAlias || ''
    form.description = props.definition.description || ''
    form.allowMultiple = props.definition.allowMultiple ? 1 : 0
    form.sort = props.definition.sort || 0
    form.status = props.definition.status || 1

    // 解析JSON字段
    if (props.definition.fileConfig) {
      try {
        form.fileConfig = typeof props.definition.fileConfig === 'string'
          ? JSON.parse(props.definition.fileConfig)
          : props.definition.fileConfig
      } catch (e) {
        form.fileConfig = { files: [] }
      }
    }
    if (props.definition.formSchema) {
      try {
        form.formSchema = typeof props.definition.formSchema === 'string'
          ? JSON.parse(props.definition.formSchema)
          : props.definition.formSchema
      } catch (e) {
        form.formSchema = { type: 'object', properties: {}, required: [] }
      }
    }
  } else {
    // 新增模式
    form.categoryId = props.categoryId
  }
})

function addFileField() {
  form.fileConfig.files.push({
    fieldCode: '',
    label: '',
    required: false,
    accept: '',
    maxSize: 0
  })
}

function removeFileField(index) {
  form.fileConfig.files.splice(index, 1)
}

function handleSave() {
  // 基础信息校验
  if (!form.categoryId) {
    ElMessage.warning('请选择分类')
    activeTab.value = 'basic'
    return
  }
  if (!form.code.trim()) {
    ElMessage.warning('请输入类型编码')
    activeTab.value = 'basic'
    return
  }
  if (!form.name.trim()) {
    ElMessage.warning('请输入类型名称')
    activeTab.value = 'basic'
    return
  }

  // 表单设计校验
  if (form.formSchema.properties && Object.keys(form.formSchema.properties).length > 0) {
    const errors = []
    const fieldNames = new Set()

    // 检查 required 数组中是否有空字段名
    if (form.formSchema.required && form.formSchema.required.length > 0) {
      const emptyRequired = form.formSchema.required.filter(f => !f || !f.trim())
      if (emptyRequired.length > 0) {
        errors.push('必填字段中存在无效字段名，请检查表单设计')
      }
    }

    for (const [fieldName, config] of Object.entries(form.formSchema.properties)) {
      // 检查字段名是否为空
      if (!fieldName || !fieldName.trim()) {
        errors.push('存在字段名为空的字段，请删除或填写标题')
        continue
      }

      // 检查字段名是否重复
      if (fieldNames.has(fieldName)) {
        errors.push(`字段名"${fieldName}"重复`)
      }
      fieldNames.add(fieldName)

      // 检查标题是否为空
      if (!config.title || !config.title.trim()) {
        errors.push(`字段"${fieldName}"的标题不能为空`)
      }

      // 检查枚举值是否为空（如果是下拉选择）
      if (config.type === 'select') {
        if (!config.enumValues || config.enumValues.length === 0) {
          errors.push(`字段"${fieldName}"的枚举值不能为空`)
        }
      }

      // 检查日期格式是否有效（如果是日期类型）
      if (config.type === 'date') {
        const validFormats = ['date', 'datetime', 'time']
        if (!config.format || !validFormats.includes(config.format)) {
          errors.push(`字段"${fieldName}"的日期格式无效，请选择日期、日期时间或时间`)
        }
      }
    }

    if (errors.length > 0) {
      ElMessage.warning(errors.join('；'))
      activeTab.value = 'form'
      return
    }
  }

  const payload = {
    categoryId: form.categoryId,
    code: form.code,
    name: form.name,
    nameAlias: form.nameAlias || null,
    description: form.description || null,
    allowMultiple: form.allowMultiple,
    sort: form.sort || 0,
    status: form.status,
    fileConfig: form.fileConfig.files.length > 0 ? form.fileConfig : null,
    formSchema: Object.keys(form.formSchema.properties || {}).length > 0 ? form.formSchema : null
  }

  emit('save', payload)
}
</script>

<style scoped>
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
